import React,{useEffect} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {useGlobalState} from '../../../state';
// import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';
import { version, FarmType } from '../../../common/enums';
import "./style.css"

import FarmDashGraph from './farmGraph';
import { BsThermometerHalf, BsThermometerHigh } from "react-icons/bs";
import { TbScale, TbTrendingUp, TbHeartBroken, TbEggs, TbCurrencyRupee, TbBasket } from "react-icons/tb";
import { IoEggOutline } from "react-icons/io5";
import { CiBag1 } from "react-icons/ci";
import { LuBird } from "react-icons/lu";
import { GiChicken } from "react-icons/gi";

const StatItem = ({ className, icon: Icon, color, bg, value, label }) => (
    <div className={className}>
        <div className='flex-center' style={{ justifyContent: 'flex-start', gap: 8 }}>
            <div className='icon-bg' style={{ background: bg, width: 36, height: 36, flexShrink: 0 }}>
                <Icon color={color} size={20} />
            </div>
            <div style={{ textAlign: 'left' }}>
                <Typography variant="h5" component="h2">
                    {value}
                </Typography>
                <Typography color="textSecondary">
                    {label}
                </Typography>
            </div>
        </div>
    </div>
);


const useCardStyles = makeStyles(theme => ({
    cardContainer:{
        width:'inherit'
    },
    card: {
        // minWidth: 387
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    media: {
        height: 40,
        backgroundSize: 'contain',
        marginTop:'3px'
    },
    cardAction:{
        margin: 'auto'
    },
    grid:{
        padding: '6px 8px',
        textAlign: 'center',
        '& .MuiTypography-h5': {
            fontSize: 16,
            fontWeight: 600,
            lineHeight: 1.3
        },
        '& .MuiTypography-colorTextSecondary': {
            textTransform: 'uppercase',
            fontSize: 11,
            lineHeight: 1.3
        }
    },
    customSpacing: {
        whiteSpace: "pre",
    },
}));

const FarmCard = ({farm, onDelete, onEdit,history, farmReport, onFarmDetails, weatherData,weeklyData,isMainDash,
totalFarms}) => {
    const classes = useCardStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [{user}] = useGlobalState();


    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        setAnchorEl(null);
        onDelete(farm);
    };

    const handleEdit = () => {
        setAnchorEl(null);
        onEdit(farm);
    };

    const handleDetail = () => {
        onFarmDetails(farm)
    }

    const onload=()=>{
        console.debug(farmReport)
    }
    const {name, location, pincode,id} = farm;
    const isBroiler = farm.farmType === FarmType.BROILER;

    const infoText = isBroiler ? `
    All sheds with live birds are
    used for calculation.

    Body weight, FCR and mortality %
    are averaged across sheds by
    the number of live birds.
    ` : `
    The following conditions are not
    used for calculation,

    1. AGE <=25 & PROD % <= 75%
    2. PROD % < 0
    3. PROD % >=100
    `
    useEffect(onload, []);

    const isMultiFarm  = (totalFarms > 1 );

    /* return (
        <FarmCardUI />
    ) */

    // xl follows lg (it used to be a fixed 8/12, so on large monitors every card took most of the row); 4 per row for multiple farms
    return <Grid item xl={isMultiFarm ? 3 : (isMainDash ? 12 : 4)} lg={(!isMultiFarm && isMainDash) ? 12 : 4} md={!isMultiFarm ? 12 : 4} sm={!isMultiFarm ? 8 : 6}  xm={4} className={classes.cardContainer}>
        <Card className={classes.card}>
            <CardHeader
                action={
                    <div style={{display:'flex'}}>
                        {user.versionID !== version.lite && weatherData.weatherDate &&
                              <div>
                                <img className={classes.media} src={`${weatherData.iconCode}`}
                               alt="weather Icon"
                               />
                               <p style={{fontSize:"14px", lineHeight:"1rem",marginTop:"-8px",marginLeft:"1px"}}>{parseFloat((weatherData.minTemp + weatherData.maxTemp)/2).toFixed(2)} &#8451;</p>
                              </div>
                        }
                        <Tooltip
                        arrow
                        disableFocusListener
                        leaveDelay={500}
                        title={<span style={{fontSize:"14px", lineHeight:"1rem",}}>{infoText}</span>}
                        classes={{ tooltip: classes.customSpacing }}>
                            <IconButton aria-label="info">
                                <InfoIcon />
                            </IconButton>
                        </Tooltip>
                        <IconButton aria-label="settings" onClick={handleClick}>
                            <MoreVertIcon/>
                        </IconButton>
                    </div>

                }
                title={name}
                subheader={<Typography style={{color:'#546e7a'}}>{location} - {pincode} <br/> {farmReport.date}</Typography>}
            />
            <CardContent>
                <Grid
                    container
                    justify='center'
                    alignItems='flex-end'
                    className={classes.topBar}
                >
                <div style={{
                    width:'100%',
                    display:'grid',
                    margin: '0 1rem',
                    gridTemplateColumns:'repeat(2, 1fr)',
                }}>
                {user.versionID === version.proPlus && weatherData.weatherDate ?
                    <React.Fragment>
                        <StatItem className={classes.grid} icon={BsThermometerHalf} color='#2980b9' bg='#eaf4fb'
                            value={<>{weatherData.minTemp} &#8451;</>} label='Min Temp' />
                        <StatItem className={classes.grid} icon={BsThermometerHigh} color='#e74c3c' bg='#fdecea'
                            value={<>{weatherData.maxTemp} &#8451;</>} label='Max Temp' />
                    </React.Fragment>
                : null}
                {isBroiler ?
                    <React.Fragment>
                        <StatItem className={classes.grid} icon={TbScale} color='#8e44ad' bg='#f4ecf7'
                            value={(farmReport.bodyWeight || 0).toFixed(0)} label='Avg Body Weight (g)' />
                        <StatItem className={classes.grid} icon={TbTrendingUp} color='#2c3e50' bg='#eaedf0'
                            value={(farmReport.fcr || 0).toFixed(3)} label='FCR (Cum.)' />
                        <StatItem className={classes.grid} icon={LuBird} color='#f39c12' bg='#fef5e7'
                            value={(farmReport.feedIntakePerGram || 0).toFixed(1)} label='Feed Per Bird' />
                        <StatItem className={classes.grid} icon={GiChicken} color='#27ae60' bg='#e9f7ef'
                            value={farmReport.liveBirds || 0} label='Live Birds' />
                        <StatItem className={classes.grid} icon={TbHeartBroken} color='#e74c3c' bg='#fdecea'
                            value={(farmReport.mortalityPercentage || 0).toFixed(2)} label='Mortality %' />
                        {
                            (!isMainDash) &&
                            <StatItem className={classes.grid} icon={CiBag1} color='#d35400' bg='#fbeee6'
                                value={(farmReport.feedIntake || 0).toFixed(2)} label='Feed Intake' />
                        }
                    </React.Fragment>
                :
                    <React.Fragment>
                    <StatItem className={classes.grid} icon={IoEggOutline} color='#2980b9' bg='#eaf4fb'
                        value={farmReport.produtionPercentage !== null && farmReport.produtionPercentage !== undefined ?
                        (farmReport.produtionPercentage).toFixed(2) : 0}
                        label='Production %' />
                    {
                        (user.versionID === version.proPlus) 
                        ? 
                        <StatItem className={classes.grid} icon={TbEggs} color='#f39c12' bg='#fef5e7'
                            value={farmReport.prodution !== null && farmReport.prodution !== undefined ? 
                            (farmReport.prodution) : 0}
                            label='Production' />
                        :
                        <StatItem className={classes.grid} icon={LuBird} color='#f39c12' bg='#fef5e7'
                            value={farmReport.feedIntakePerGram !== null && farmReport.feedIntakePerGram !== undefined ? 
                            (farmReport.feedIntakePerGram).toFixed(1) : 0}
                            label='Feed Per Bird' />
                    }
                    {
                        (user.versionID === version.proPlus)
                        ? 
                        <StatItem className={classes.grid} icon={CiBag1} color='#d35400' bg='#fbeee6'
                            value={farmReport.feedIntake !== null && farmReport.feedIntake !== undefined ? 
                            (farmReport.feedIntake).toFixed(2) : 0}
                            label='Feed Intake' />
                        :
                        <StatItem className={classes.grid} icon={TbEggs} color='#f39c12' bg='#fef5e7'
                            value={farmReport.prodution !== null && farmReport.prodution !== undefined ? 
                            (farmReport.prodution) : 0}
                            label='Production' />
                    }
                    {
                        (!isMainDash) && 
                        <>{
                            (user.versionID === version.proPlus)
                             ?
                             <StatItem className={classes.grid} icon={TbCurrencyRupee} color='#27ae60' bg='#e9f7ef'
                                 value={farmReport.sales !== null && farmReport.sales !== undefined ? 
                                 (farmReport.sales).toFixed(2) : 0}
                                 label='Sales' />
                             :
                             <StatItem className={classes.grid} icon={CiBag1} color='#d35400' bg='#fbeee6'
                                 value={farmReport.feedIntake !== null && farmReport.feedIntake !== undefined ? 
                                 (farmReport.feedIntake).toFixed(2) : 0}
                                 label='Feed Intake' />
                        }
                        </>
                    }
                    {user.versionID === version.proPlus ? 
                        <React.Fragment>
                            {
                                (!isMainDash) ?
                                <StatItem className={classes.grid} icon={TbBasket} color='#8e44ad' bg='#f4ecf7'
                                    value={farmReport.eggsPerBag !== null && farmReport.eggsPerBag !== undefined ? 
                                    (farmReport.eggsPerBag).toFixed(2) : 0}
                                    label='Eggs Per Bag' />
                               :
                               <StatItem className={classes.grid} icon={LuBird} color='#f39c12' bg='#fef5e7'
                                    value={farmReport.feedIntakePerGram !== null && farmReport.feedIntakePerGram !== undefined ? 
                                    (farmReport.feedIntakePerGram).toFixed(1) : 0}
                                    label='Feed Per Bird' />
                            }
                        </React.Fragment>
                    : null}
                    </React.Fragment>
                }
                </div>
                    {
                        (isMainDash || (user.versionID === version.lite) || (user.versionID === version.pro)  ) &&
                        <Grid container style={{marginTop:'5px', padding:'0 16px'}}>
                             <FarmDashGraph  farm={farm} weeklyData={weeklyData}
                                onFarmDetails={onFarmDetails} isBroiler={isBroiler}/>
                        </Grid>
                    }
                </Grid>
            </CardContent>
            <CardActions >
                <Button className={classes.cardAction} size="large" color="primary" variant='outlined'
                onClick={()=>{
                    if(user.role === "SUPER"){
                        history.push(`/farm/${id}/daily-entry`)
                    } else if (user.role === "FEEDSUPER") {
                        history.push(`/daily-entry-feed`)
                    }
                    else{ 
                        history.push(`/farm/${id}/dashboard`)
                    }
                    window.localStorage.setItem("farmName",name)
                }}>Click here for more details</Button>
            </CardActions>
        </Card>
        <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            <MenuItem onClick={handleDetail}>Details</MenuItem>
            {
                (user.role === "ADMIN") &&
                <>
                    <MenuItem onClick={handleEdit}>Edit</MenuItem>
                    <MenuItem onClick={handleDelete}>Delete</MenuItem>
                </>
            }
        </Menu>

        {/* TODO
            Add a single bar chart for all farm cards dataa (Take production % and sale values alone)
        */}
    </Grid>
};

// eslint-disable-next-line no-unused-vars
const FarmCardUI = ({ farmName }) => {
    return (
        <div className="farm-card-container">

            <div className="farm-card-top">
                <div className="farm-card-info">
                    <div className="farm-card-name">
                        Farm Name
                    </div>

                    <div className="farm-card-description">
                        farm description
                    </div>
                </div>

                <div className="farm-card-menu">
                    3 dots
                </div>
            </div>

            <div className="farm-card-middle">
                chart
            </div>

            <div className="farm-card-bottom">

                <div className="farm-card-stat">
                    <div className="farm-card-stat-label">
                        Production %
                    </div>
                    <div className="farm-card-stat-value">
                        84.5%
                    </div>
                </div>

                <div className="farm-card-stat">
                    <div className="farm-card-stat-label">
                        Production
                    </div>
                    <div className="farm-card-stat-value">
                        2929
                    </div>
                </div>

                <div className="farm-card-stat">
                    <div className="farm-card-stat-label">
                        Feed Intake
                    </div>
                    <div className="farm-card-stat-value">
                        84.5%
                    </div>
                </div>

                <div className="farm-card-stat">
                    <div className="farm-card-stat-label">
                        Feed Per Bird
                    </div>
                    <div className="farm-card-stat-value">
                        84.5%
                    </div>
                </div>

            </div>
        </div>
    );
};
export default FarmCard;